import { render } from "./chatMessage.vue?vue&type=template&id=cd600d14&ts=true"
import script from "./chatMessage.vue?vue&type=script&lang=ts"
export * from "./chatMessage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__